export class StrapiRuleAttribute { // ArticleAttribute
  flags = new Array<StrapiArticleFlag>();
  triggers = new Array<StrapiArticleTrigger>();
  rules = new Array<StrapiArticleRule>();
}

export class StrapiArticleFlag {
  name: string;
  value: boolean;
}

export class StrapiArticleTrigger {
  name: string;
  value: string;
}

export class StrapiArticleRule {
  name: string;
  conditions: string;
  updates: string;
  trigger = new StrapiArticleTrigger();
}
